module.exports = __webpack_public_path__ + "static/media/36-2.23c4d5f0.mp3";